import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Icon, Skeleton, Row, Col, Button } from "antd";
import qs from "query-string";
import logoLS from "../../assets/logo/linksight-logo.svg";
import "./AccountValidation.css";
import { verifyEmail } from "../../utils/auth";
// import logoLR from "../../assets/logo_localranker.svg";
// import sideImage from "../../assets/local-ranker-side.png";

const DoubleOptin = () => {
  const location = useLocation();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [displaySuccess, setDisplaySuccess] = useState(false);
  const [displayFailure, setDisplayFailure] = useState(false);
  const [displayCheckInbox, setDisplayCheckInbox] = useState(true);

  useEffect(() => {
    const parseURL = () => {
      setLoading(true);
      const id = qs.parse(location.search);
      console.log(id);
      if (Object.entries(id).length !== 0) {
        setDisplayCheckInbox(false);
        // API CALL TO ENDPOINTS TO VALIDATE EMAIL
        confirmEmail(id.id);
      } else {
        setLoading(false);
      }
    };
    parseURL();
    // eslint-disable-next-line
  }, []);

  const confirmEmail = async (id) => {
    const verification = await verifyEmail(id);
    if (verification === true) {
      setDisplaySuccess(true);
      setLoading(false);
    } else {
      setDisplayFailure(true);
      setLoading(false);
    }
  };

  const handleClearCookie = () => {
    localStorage.clear();
    console.debug("Signing, reloading...");
    history.push("/signin");
  };

  return (
    <div className="signup-container">
      <Row>
        <Col xl={8} lg={8} md={24} sm={24} xs={24}>
          <div className="block-signin">
            <div className="heading-auth">
              <div className="logo-ls">
                <img src={logoLS} alt="logo local ranker" width="190px" />
              </div>

              {loading && <Skeleton active />}

              {displayCheckInbox && !loading && (
                <>
                  <p className="main-sentence-body">
                    <b>
                      <span role="img" aria-label="emoji">
                        💌
                      </span>{" "}
                      Vérifiez votre boîte de réception !
                    </b>
                  </p>
                  <br />
                  <p>Nous venons de vous envoyer un email de validation.</p>
                  <div className="hr-line" />
                  <div className="hr-line-validation">
                    <div>Vous avez déjà validé votre compte ?</div>
                  </div>
                </>
              )}
              {displaySuccess && !loading && (
                <>
                  <span className="main-sentence-body">
                    <b>
                      <span role="img" aria-label="emoji">
                        ✅
                      </span>{" "}
                      Votre compte est bien validé
                    </b>
                  </span>
                  <br />
                  <p>Connectez-vous pour profiter de Linksight</p>
                </>
              )}
              {displayFailure && !loading && (
                <span className="main-sentence-body">
                  <b>
                    <span role="img" aria-label="emoji">
                      ❌
                    </span>{" "}
                    Oh-oh! Nous n'avons pas réussi à vérifier votre compte.
                  </b>
                </span>
              )}

              <Button
                className="signup-button-valid"
                type="primary"
                htmlType="submit"
                onClick={() => {
                  handleClearCookie();
                }}
              >
                Connectez-vous maintenant <Icon type="arrow-right" />
              </Button>
            </div>
          </div>
        </Col>
        <Col
          xl={16}
          lg={16}
          md={24}
          sm={24}
          xs={24}
          className="block-image"
        ></Col>
      </Row>
    </div>
  );
};

export default DoubleOptin;
